'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = ['', 'M248 0l56 0 24 0 0 24 0 152 32 0 24 0 0 48-24 0-56 0-56 0-24 0 0-48 24 0 32 0 0-128-32 0-24 0 0-48 24 0zM24 288l56 0 24 0 0 24 0 152 32 0 24 0 0 48-24 0-56 0-56 0L0 512l0-48 24 0 32 0 0-128-32 0L0 336l0-48 24 0zM0 0L24 0 168 0l24 0 0 24 0 176 0 24-24 0L24 224 0 224l0-24L0 24 0 0zM48 48l0 128 96 0 0-128L48 48zM216 288l144 0 24 0 0 24 0 176 0 24-24 0-144 0-24 0 0-24 0-176 0-24 24 0zm24 176l96 0 0-128-96 0 0 128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;